export const getArticle = (word: string) => {
  if (!word) return ""
  const vowels = ["a", "e", "i", "o", "u"]
  return vowels.includes(word[0].toLowerCase()) ? "an" : "a"
}
